import type { Author as EncodedAuthor } from '@/shared/api/experience';

import type { Author } from './models';

export const normalizeAuthor = (encoded: EncodedAuthor): Author => {
  return {
    id: encoded.id,
    fullName: encoded.name,
    description: encoded.description ?? '',
    avatarLink: encoded.avatar_url ?? '',
    isRedaction: Boolean(encoded.is_redaction),
  };
};
